import React from "react";
import classNames from "classnames";
import AnalysisColoredBox from "./AnalysisColoredBox/AnalysisColoredBox";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import FormatCurrency from "../../../landingPage/pages/Homepage/components/FormatCurrency";
import withTranslations from "../../../../../hocs/withTranslations";
import { compose } from "redux";
import { ANALYSIS_COLORED_BOX_VARIANTS } from "../../../../../lib/analysisColoredBoxVariants";

const formatHighlightPrice = ({ value, locale, currency }) =>
  typeof value === "number"
    ? FormatCurrency({
        locale,
        currency,
        value
      })
    : value;

function AnalysisHighlights({
  stockId,
  stockName,
  locale,
  currency,
  highlights,
  title,
  translate
}) {
  const isDesktop = useIsDesktop();

  const necessaryCondition = highlights?.necessaryCondition;
  const hasNecessaryCondition = necessaryCondition != null;
  const necessaryConditionPrice = necessaryCondition?.price;

  const hasNecessaryConditionPrice = necessaryConditionPrice != null;
  const necessaryConditionDisplayPrice = hasNecessaryConditionPrice
    ? formatHighlightPrice({
        value: necessaryConditionPrice,
        locale,
        currency
      })
    : translate("analysis-highlights_no-data");
  const necessaryConditionDescription = necessaryCondition?.description;

  const targetLevelPrice = highlights?.targetLevel?.price;
  const hasTargetLevelPrice = targetLevelPrice != null;
  const targetLevelDisplayPrice = formatHighlightPrice({
    value: targetLevelPrice,
    locale,
    currency
  });
  const targetLevelDescription = highlights?.targetLevel?.description;

  const levelOfNegationPrice = highlights?.levelOfNegation?.price;
  const hasLevelOfNegationPrice = levelOfNegationPrice != null;
  const levelOfNegationDisplayPrice = formatHighlightPrice({
    value: levelOfNegationPrice,
    locale,
    currency
  });
  const levelOfNegationDescription = highlights?.levelOfNegation?.description;

  const shouldShowHighlights =
    highlights !== null &&
    (hasNecessaryCondition || hasTargetLevelPrice || hasLevelOfNegationPrice);

  if (!shouldShowHighlights) {
    return null;
  }

  return (
    <div
      className={classNames("grid mb-6", {
        "grid-cols-3 gap-6": isDesktop,
        "grid-cols-1 gap-3": !isDesktop
      })}
    >
      {hasNecessaryCondition ? (
        <AnalysisColoredBox
          onClick={
            hasNecessaryConditionPrice
              ? () => {
                  showModal("NewPriceAlertsModal", {
                    stockId,
                    stockName,
                    price: necessaryConditionPrice,
                    description: `${title} – ${translate(
                      `${ANALYSIS_COLORED_BOX_VARIANTS.NECESSARY_CONDITION}_title`
                    )}`
                  });
                }
              : undefined
          }
          price={necessaryConditionDisplayPrice}
          description={necessaryConditionDescription}
          variant={ANALYSIS_COLORED_BOX_VARIANTS.NECESSARY_CONDITION}
        />
      ) : null}
      {hasTargetLevelPrice ? (
        <AnalysisColoredBox
          onClick={() => {
            showModal("NewPriceAlertsModal", {
              stockId,
              stockName,
              price: targetLevelPrice,
              description: `${title} – ${translate(
                `${ANALYSIS_COLORED_BOX_VARIANTS.TARGET_LEVEL}_title`
              )}`
            });
          }}
          price={targetLevelDisplayPrice}
          description={targetLevelDescription}
          variant={ANALYSIS_COLORED_BOX_VARIANTS.TARGET_LEVEL}
        />
      ) : null}
      {hasLevelOfNegationPrice ? (
        <AnalysisColoredBox
          onClick={() => {
            showModal("NewPriceAlertsModal", {
              stockId,
              stockName,
              price: levelOfNegationPrice,
              description: `${title} – ${translate(
                `${ANALYSIS_COLORED_BOX_VARIANTS.LEVEL_OF_NEGATION}_title`
              )}`
            });
          }}
          price={levelOfNegationDisplayPrice}
          description={levelOfNegationDescription}
          variant={ANALYSIS_COLORED_BOX_VARIANTS.LEVEL_OF_NEGATION}
        />
      ) : null}
    </div>
  );
}

export default compose(withTranslations)(AnalysisHighlights);
